import Link from "next/link";
import  BannerImage from "./BannerImage";
import { Box, Card, Flex, Inset } from "@radix-ui/themes";

export function BlogCard({ blog }) {


    return (
        <>
            <Link className="card-link" href={blog.path ? blog.path : blog.slug}>
                <Card size="3" className="blog-card" style={{height: "100%"}}>
                    <Flex direction="column" gap="5">
                        <Inset side="top" mb="0">
                            <BannerImage blog={blog} title={blog.title} />
                        </Inset>
                        <h3>{blog.title}</h3>
                        <Box>
                            {blog?.seo?.description}
                        </Box>
                    </Flex>
                </Card>
            </Link>
            <style jsx>
                {`
                :global(.card-link) {
                  text-decoration: none;
                }
              `}
            </style>
        </>
    );
}
